import { ClientFactory } from "@/main/common/ClientFactory";
import { MetaHandler } from "@/main/common/MetaHandler";
import { isLikelyCrawlerUserAgent } from "@/main/common/BotDetection";

// First-touch attribution moved from the server render to this beacon (board round 93 D5, r94 `2c`): an anonymous
// `/discussion/*` page is edge-cacheable, so it may carry no `Set-Cookie`, and the `sv_attrib` cookie is minted on the
// beacon's no-store AJAX response instead. Called once per HARD landing from `bootstrapFrontEnd`'s one-time setup,
// BEFORE any island mounts, so the landing still has the UTM tags / share token a later URL-cleaning effect may strip.
// Signed-out viewers only (the server no-ops for a signed-in one anyway). It fires on every anonymous landing, not only
// a cookie-less one: `sv_attrib` is HttpOnly, so this side cannot see it, and the server's first-touch-wins guard makes
// a repeat a no-op. Mechanism: designs/01-now/2026-06-11-rendering-convergence-edge-cacheable-ssr-hydration-phased-plan.md
// §3 "Step 2 as built".

let sent = false;

export function sendFirstTouchBeacon(): void {
    if (sent || typeof window === "undefined" || typeof document === "undefined") {
        return;
    }
    sent = true;
    if (MetaHandler.isUserLoggedIn()) {
        return;
    }
    // FI-3103 (board r125 D8): a named crawler is not an arrival. Its rows were excluded by every readout and only
    // cost writes and the 14-day crawler purge. Automation clients are not crawlers and still send (BotDetection.ts).
    if (isLikelyCrawlerUserAgent()) {
        return;
    }
    void ClientFactory.reportFirstTouch(window.location.pathname + window.location.search, document.referrer || "");
}

export function resetFirstTouchBeaconForTests(): void {
    sent = false;
}
